import React,{useRef} from 'react';
import { FaArrowRight } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import TextField from '@mui/material/TextField';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Footer.css'
import {Link} from 'react-router-dom'

export default function Footer() {
    const form = useRef();
    const formik = useFormik({
    initialValues: {
      user_email: '',
    },
    validationSchema: Yup.object({
        user_email: Yup.string()
        .required('*Fill user email*')
        .email('*Invalid email address*'),
    }),
    onSubmit: (values) => {
      console.log(values);
      toast("Your Email Sent Successfully!")

      emailjs
        .sendForm('service_d1hrkom', 'template_zf1wexk', form.current, 'tTvO7herDJDWHxQ51')
        .then(
          (result) => {
            console.log(result.text, 'email sent');
           
          },
          (error) => {
            console.log(error.text);
          }
        );
      formik.resetForm();
    },
    });
      
    return (
        <>
          <section className="info_section layout_padding2">
            <div className="container">
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
              <div className="row">
                <div className="col-md-6 col-lg-4 info_col">
                  <div className="info_contact">
                    <h4>Address</h4>
                      <div className="contact_link_box">
                        <a href="">
                          <i className="fa fa-map-marker" aria-hidden="true" />
                          <span>Location</span>
                        </a>
                        <a href="">
                          <i className="fa fa-phone" aria-hidden="true" />
                          <span>Call +91 8479089674</span>
                        </a>
                        <a href="">
                          <i className="fa fa-envelope" aria-hidden="true" />
                          <span className='email-span'>currencygrowthfinancialservice@gmail.com</span>
                        </a>
                      </div>
                  </div>
                  {/* <div className="info_social">
                    <a href="">
                      <i className="fa fa-facebook" aria-hidden="true" />
                    </a>
                    <a href="">
                      <i className="fa fa-twitter" aria-hidden="true" />
                    </a>
                    <a href="">
                      <i className="fa fa-linkedin" aria-hidden="true" />
                    </a>
                    <a href="">
                      <i className="fa fa-instagram" aria-hidden="true" />
                    </a>
                  </div> */}
                </div>
                <div className="col-md-6 col-lg-3 info_col">
                  <div className="info_detail">
                    <h4>Info</h4>
                    <p>Welcome to Currency Growth Financial Services, where financial success meets personalized service. Established with a commitment to empower individuals and businesses, we are more than advisors; we are partners in your journey towards prosperity.</p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-2 mx-auto info_col">
                  <div className="info_link_box">
                    <h4>Links</h4>
                    <div className="info_links">
                    <Link  to="/home">
                      Home
                    </Link>
                    <Link  to="/about">
                      About
                    </Link>
                    <Link  to="/services">
                      Services
                    </Link>
                    <Link  to="/contact">
                      Contact Us
                    </Link>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3 info_col ">
                  <h4>Join Our Newsletter</h4>
                  <h6>For Our Latest Updates & Promotions</h6>
                  <form
                    action="#"
                    style={{ marginTop: '15px' }}
                    ref={form}
                    onSubmit={(e) => {
                      e.preventDefault();
                      formik.handleSubmit();
                      if (formik.errors.user_email) {
                        toast.error('Invalid email address');
                      }
                    }}
                  >
                    <div className='footer-textfield-main'>
                      <div className='footer-textfield'>
                        <TextField
                          id="standard-basic"
                          label="Enter email"
                          variant="standard"
                          name="user_email"
                          type="text"
                          fullWidth
                          value={formik.values.user_email}
                          onChange={formik.handleChange}
                          sx={{
                              width:"235px",
                              "& label": {
                              color: "white",
                              marginLeft:'15px',
                              },
                              "& input:focus": {
                              backgroundColor: "white",
                              color: 'black',
                              },
                          }}
                        />
                      </div>
                      <button type="submit" style={{ backgroundColor: "transparent", border: "none", cursor: "pointer",width:'5px',padding:"15px" }}>
                        <FaArrowRight className="footer-arrow-icon"/>
                      </button>
                    </div>
                    {formik.touched.user_email && formik.errors.user_email && (
                      <div>
                        <p style={{ color: 'red', marginTop: '5px' }}>{formik.errors.user_email}</p>
                      </div>
                    )}  
                  </form>
                  <div className='footer-icon'>
                    <div className='footer-icon-facebook'>
                      <FaFacebookF style={{height:"16px",width:'16px'}}/>
                    </div>
                    <div className='footer-icon-whatsapp'>
                      <FaWhatsapp style={{height:"18px",width:'20px'}}/>
                    </div>
                    <div className='footer-icon-twitter'>
                      <FaTwitter style={{height:"16px",width:'16px'}}/>
                    </div>
                    <div className='footer-icon-instra'>
                      <FaInstagram style={{height:"16px",width:'16px'}}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="footer_section">
            <div className="container">
              <span>
                © Currency Growth Financial Services. 
                {/* <Link  to="/disclaimer">Disclaimer</Link> || 
                <Link  to="/privacy-policy">PrivacyPolicy</Link> */}
              </span> &nbsp;
              <span><Link  to="/disclaimer">Disclaimer</Link> || </span>
              <span><Link  to="/privacy-policy">PrivacyPolicy</Link></span>
            </div>
          </section>
        </>

    )
}
